module.exports = __webpack_public_path__ + "static/piantinaA-2548f8c4a4e38f550a601c1b5d218a60.png";